import { Link } from 'gatsby-plugin-react-i18next'
import React, { FC } from 'react'
import Button from 'src/components/ui/Button'

interface ICaseStudyLinkButtonProps {
  ctaLink: string
  ctaText: string
  className?: string
}

const CaseStudyLinkButton: FC<ICaseStudyLinkButtonProps> = ({
  ctaLink,
  ctaText,
  className,
}) => (
  <div className={className}>
    <Link to={ctaLink}>
      <Button>{ctaText}</Button>
    </Link>
  </div>
)

CaseStudyLinkButton.defaultProps = {
  className: '',
}

export default CaseStudyLinkButton
